import { observable } from "mobx";

export default class SearchStore {
    @observable public sensorSearch: string = '';
}